import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Empêche le navigateur de restaurer l'ancienne position de scroll (boutons précédent/suivant)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    // Le scroll réel de l'app se fait sur #root (overflow-y: auto), pas sur window.
    // On remet les deux à zéro pour couvrir tous les cas.
    const root = document.getElementById('root');
    if (root) {
      root.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}